import { observer } from 'mobx-react-lite';
import { ApplicationSdk } from '../../../../core/sdk';
import OrderOverviewStore from '../stores/OrderOverviewStore';
import React, { useState } from 'react';
import { getOrderItemStatusInfo, OrderItem } from '../models/OrderItem';
import { Card } from 'primereact/card';
import { formatDate } from '../../../../utils/helper';
import { Dialog } from 'primereact/dialog';

export const OrderOverview = observer(
    ({ sdk, currentStore }: { sdk: ApplicationSdk; currentStore: OrderOverviewStore }) => {
        const [dialogData, setDialogData] = useState<{
            order: any;
        } | null>(null);

        const renderOrderItem = (order: OrderItem) => {
            const orderStatusInfo = getOrderItemStatusInfo(order);

            return (
                <Card
                    header={undefined}
                    key={order.id}
                    footer={undefined}
                    pt={{
                        body: { style: { padding: 0 } },
                        content: { style: { padding: '0.25rem 0' } },
                        header: {
                            style: {
                                fontSize: '1.25rem',
                                fontWeight: '600',
                                padding: '0 1rem',
                                display: 'flex',
                                alignItems: 'center',
                            },
                        },
                        footer: {
                            style: {
                                padding: '0 0.5rem',
                                borderTop: '1px solid #e9ecef',
                                fontWeight: '500',
                            },
                        },
                    }}
                    style={{
                        marginBottom: '0.5rem',
                        padding: '0.5rem',
                        backgroundColor: orderStatusInfo.cardBgColor,
                        border: `1px solid ${orderStatusInfo.chipColor}20`,
                        cursor: 'default',
                    }}
                    onClick={() => {
                        currentStore.openViewOrder(order.id);
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'stretch',
                            gap: '0.5rem',
                            minHeight: '60px',
                        }}
                    >
                        <div
                            style={{
                                width: '60px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '4px',
                                flexShrink: 0,
                            }}
                        >
                            <i
                                className={`pi ` + orderStatusInfo.icon}
                                style={{
                                    fontSize: '1.5rem',
                                    color: '#6c757d',
                                }}
                            ></i>
                        </div>
                        <div
                            style={{
                                flex: 1,
                                minWidth: 0,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'start',
                            }}
                        >
                            <div
                                style={{
                                    fontSize: '0.75rem',
                                    color: '#666',
                                    marginBottom: '0.25rem',
                                    fontWeight: '600',
                                }}
                            >
                                {order.objectName}
                            </div>

                            <div
                                style={{
                                    fontSize: '0.875rem',
                                    color: '#333',
                                    marginBottom: '0.25rem',
                                    lineHeight: '1.2',
                                    fontWeight: '600',
                                }}
                            >
                                Bestelldatum: {formatDate(order.createdUtc, true)}
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.375rem',
                                    flexWrap: 'wrap',
                                }}
                            >
                                <span
                                    style={{
                                        padding: '0.25rem 0.5rem',
                                        borderRadius: '10px',
                                        fontSize: '0.8rem',
                                        fontWeight: '600',
                                        color: orderStatusInfo.chipColor,
                                        backgroundColor: orderStatusInfo.chipBgColor,
                                        border: `1px solid ${orderStatusInfo.chipColor}`,
                                        lineHeight: '1',
                                    }}
                                >
                                    {orderStatusInfo.label}
                                </span>
                            </div>
                        </div>
                    </div>
                </Card>
            );
        };

        return currentStore ? (
            <div style={{ margin: '0 auto', maxWidth: '400px' }}>
                {currentStore.orderList && currentStore.orderList.length > 0 ? (
                    <div style={{ maxWidth: '600px' }}>
                        {currentStore.orderList.map((order: OrderItem) => renderOrderItem(order))}
                    </div>
                ) : (
                    <div
                        style={{
                            position: 'fixed',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            backgroundColor: '#f8f9fa',
                            color: '#6c757d',
                            padding: '2rem',
                            borderRadius: '8px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                            textAlign: 'center',
                            zIndex: 1000,
                            width: '80%',
                            maxWidth: '500px',
                        }}
                    >
                        <i
                            className="pi pi-file-o"
                            style={{ fontSize: '2rem', marginBottom: '1rem', display: 'block' }}
                        ></i>
                        <h2 style={{ margin: 0, fontSize: '1.5rem' }}>
                            Keine Bestellungen vorhanden
                        </h2>
                        <p style={{ marginTop: '1rem', fontSize: '1rem' }}>
                            Sie haben noch keine Bestellungen erstellt.
                        </p>
                    </div>
                )}
                <Dialog
                    header={
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                color: '#495057',
                            }}
                        >
                            <i
                                className="pi pi-comment"
                                style={{ fontSize: '1.2rem', color: '#6c757d' }}
                            ></i>
                            <span style={{ fontSize: '1.1rem', fontWeight: '600' }}>Kommentar</span>
                        </div>
                    }
                    closable={true}
                    visible={dialogData !== null}
                    style={{ width: '90%', maxWidth: '500px' }}
                    modal
                    onHide={() => setDialogData(null)}
                    pt={{
                        header: {
                            style: {
                                padding: '1.25rem 1.5rem 1rem 1.5rem',
                                borderBottom: '1px solid #dee2e6',
                            },
                        },
                        content: {
                            style: {
                                padding: '0.5rem',
                                lineHeight: '1.6',
                            },
                        },
                    }}
                >
                    <div
                        style={{
                            marginBottom: '0.5rem',
                            padding: '0.25rem',
                        }}
                    >
                        <div
                            style={{
                                fontWeight: '600',
                                color: '#495057',
                                fontSize: '0.9rem',
                                marginBottom: '0.25rem',
                            }}
                        >
                            {dialogData ? getOrderItemStatusInfo(dialogData.order).label : ''}
                        </div>
                    </div>
                </Dialog>
            </div>
        ) : null;
    }
);

export default OrderOverview;
